import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';
import { AuthLoadingState } from '@/components/auth/AuthLoadingState';

interface SuperAdminRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

export const SuperAdminRoute = ({ 
  children, 
  fallbackPath = '/dashboard' 
}: SuperAdminRouteProps) => {
  const { user, loading: authLoading } = useAuth();
  const { loading: permissionsLoading } = usePermissions();
  const location = useLocation();

  if (authLoading || permissionsLoading) {
    return <AuthLoadingState />;
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Check super admin status directly from profile
  if (!user.profile?.is_super_admin) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
